/**
 * ONE STATUS READ PER PAGE (ease package P-5.1).
 *
 * Every screen that talks about the assistant reads `GET …/status` through this and says its
 * answer with `WASLO.STATUS.*`, so two screens can never tell one account two stories. It is
 * `useWasloApi` with `isEmpty: () => false` (a status is never "empty"), plus the two facts
 * most pages branch on.
 */
import { computed } from 'vue';

import { useWasloApi } from './useWasloApi.js';
import { wasloApi } from '../api/client.js';

export const useWasloStatus = accountId => {
  const read = useWasloApi(
    signal => wasloApi.getStatus(accountId.value, signal),
    { isEmpty: () => false }
  );
  /** `{ state, fix, resumesAt, aiEnabled, mode }`, or `null` while unread or unreadable. */
  const account = computed(() => read.data.value?.account ?? null);
  const isPractising = computed(() => account.value?.mode === 'practice');
  return { ...read, account, isPractising };
};

export default useWasloStatus;
